import React from "react";
import { useTranslation } from 'react-i18next';
import CONST from "../../config/CONST";
import {useDispatch, useSelector} from "react-redux";
import {getAppData, setIsFormLayerVisible} from "../../store/slices/appSlice";
import GATracker, {GAEventBuildObject} from "../../helpers/GATracker";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";


const FormLayerOpenCta = () => {

    const dispatch = useDispatch();

    const appData = useSelector(getAppData);
    const financialConfiguration = useSelector(getFinancialConfiguration);

    const { t } = useTranslation();

    const onClick = () => {
        dispatch(setIsFormLayerVisible(true));

        GATracker.trackEvent(GAEventBuildObject({
            event: {
                name: GATracker.EVENTS.LEAD_FORM_OPEN.name,
                category: GATracker.EVENTS.LEAD_FORM_OPEN.category,
                action: GATracker.EVENTS.LEAD_FORM_OPEN.action
            },
            appData: appData,
            financialConfiguration: financialConfiguration
        }));
    }

    if(!appData || !financialConfiguration) {
        return null;
    }

    return (
            <div className={`${CONST.CSS_NAMESPACE}FormLayerOpenCta`}>
                <button
                    title={t('FormLayerOpenCta')}
                    onClick={onClick}
                >
                    <span>{t('FormLayerOpenCta')}</span>
                </button>
            </div>
    );
};

export default FormLayerOpenCta;